module.exports = __webpack_public_path__ + "static/niegolewskich-img-4-da1a843a42e179414b266fca8a3d0b53.jpg";